module.exports = __webpack_public_path__ + "media/pro/cvv_icon-ed0f6457.png";